"use client";

import Link from "next/link";

export default function HomePage() {
    return (
        <div className="flex flex-col items-center justify-center min-h-screen w-full bg-gradient-to-br from-blue-50 to-white dark:from-gray-900 dark:to-gray-800 text-gray-900 dark:text-white transition-colors duration-300 overflow-hidden relative">
            {/* 🏆 Hero Section */}
            <div className="text-center max-w-3xl px-6 relative z-10">
                <h1 className="text-6xl font-extrabold tracking-tight mb-6 bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent dark:from-blue-400 dark:to-purple-400 animate-fadeIn">
                    Willkommen bei AnnoModels
                </h1>
                <p className="text-lg text-gray-700 dark:text-gray-300 mb-8 animate-fadeIn delay-200">
                    Erstelle und verwalte BPMN-Prozessmodelle, Entscheidungsbäume und Formulare automatisch und intuitiv.
                    Einfach, schnell und effizient.
                </p>

                {/* 🌟 Call-to-Action Buttons */}
                <div className="flex flex-wrap justify-center gap-6 animate-fadeIn delay-400">
                    <Link href="/annotation" className="px-8 py-4 text-lg font-semibold bg-blue-600 text-white rounded-xl shadow-lg hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600 transition duration-300 transform hover:scale-105">
                        🔍 Loslegen und Modelle generieren
                    </Link>
                </div>
            </div>

            {/* 💫 Hintergrund-Animation */}
            <div className="absolute inset-0 -z-10 overflow-hidden">
                {/* Leuchtender Blur-Effekt */}
                <div className="absolute top-1/4 left-1/3 w-96 h-96 bg-gradient-to-r from-blue-300 to-purple-300 rounded-full blur-3xl opacity-40 dark:opacity-20 animate-pulse"></div>
                <div className="absolute bottom-10 right-10 w-72 h-72 bg-gradient-to-r from-green-300 to-blue-300 rounded-full blur-3xl opacity-40 dark:opacity-20 animate-pulse delay-300"></div>

                {/* 🌀 Subtile Bewegungs-Animation */}
                <svg className="absolute top-0 left-0 w-full h-full opacity-10 dark:opacity-5 animate-movePattern" xmlns="http://www.w3.org/2000/svg">
                    <pattern id="circles" width="40" height="40" patternUnits="userSpaceOnUse">
                        <circle cx="10" cy="10" r="1.5" fill="currentColor"></circle>
                    </pattern>
                    <rect width="100%" height="100%" fill="url(#circles)"></rect>
                </svg>
            </div>
        </div>
    );
}